import React from "react";
import styled from "styled-components";

const CarousalItem = ({ element, index, username, currentCollectionId }) => {
  console.log();
  var collectionUrl = "/af/" + username + "/";
  return (
    <Link
      href={`${collectionUrl + element.url}`}
      key={element.collection_id}
      data-slide-no={index}
    >
      <Container className={index === 0 ? "active" : ""}>
        <Card outline={element.collection_id === currentCollectionId}>
          <CardOneContainer>
            <CardOne url={element.banner_img[0]} />
          </CardOneContainer>
          <CardTwoContainer url={element.banner_img[1]} />
          <CardThreeContainer url={element.banner_img[2]} />
        </Card>
        <CollectionTitle active={element.collection_id === currentCollectionId}>
          {element.collection_name}
        </CollectionTitle>
      </Container>
    </Link>
  );
};

export default CarousalItem;

const Link = styled.a`
  text-decoration: none;
  transform: translateX(0);
  transition: all 0.2s ease-in-out;
`;

const Card = styled.div`
  width: 9.5rem;
  height: 9.5rem;
  border-radius: 8px;

  background-image: linear-gradient(120deg, #d4fc79 0%, #96e6a1 100%);

  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  position: relative;
  overflow: hidden;
  border: 2px solid #fff;
  @media (max-width: 700px) {
    width: 8.5rem;
    height: 8.5rem;
  }
`;

const CardOneContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  z-index: 2;
  transform: rotate(45deg) translate(50%, 50%);
  border-left: 2px solid #fff;
  border-top: 2px solid #fff;

  overflow: hidden;
`;
const CardOne = styled.div`
  height: 100%;
  width: 100%;
  transform: rotate(-45deg) translateY(-40%);

  background-image: url(${props => props.url});
`;
const CardTwoContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background-image: url(${props => props.url});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  width: 50%;
  z-index: 1;
  left: 0;
  border-right: 1px solid #fff;
`;

const CardThreeContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background-image: url(${props => props.url});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  width: 50%;
  z-index: 1;
  right: 0;
  border-left: 1px solid #fff;
`;

const Container = styled.div`
  width: 9.5rem;
  min-height: 9.5rem;
  margin: 0 0.4rem;
  @media (max-width: 700px) {
    width: 8.5rem;
    min-height: 8.5rem;
  }
`;

const CollectionTitle = styled.p`
  font-size: 1rem;
  max-height: calc(1rem * 1.25 * 2 * 10px);
  overflow: hidden;
  font-weight: ${props => (props.active ? "500" : "300")};
  margin: 0;
  color: #fff;
  text-align: center;
  position: relative;

  border-bottom: ${props => (props.active ? "2px solid #fff" : "")};
  padding-bottom: 10px;
  padding-top: 5px;
`;



// WEBPACK FOOTER //
// ./src/components/CarousalItem.jsx